// Nepali Month Names in BS
export const NEPALI_MONTHS_BS = [
  'Baisakh', 'Jestha', 'Ashadh', 'Shrawan', 'Bhadra', 'Ashwin',
  'Kartik', 'Mangsir', 'Poush', 'Magh', 'Falgun', 'Chaitra'
];

/**
 * Converts an AD date string or Date object to Bikram Sambat (BS) format string.
 * @param {string|Date} adDateInput - AD Date
 * @param {'short'|'full'} format - 'short' (2081/04/19 BS) or 'full' (2081 Shrawan 19 BS)
 */
export const formatAdToBs = (adDateInput, format = 'short') => {
  if (!adDateInput) return '-';
  const d = new Date(adDateInput);
  if (isNaN(d.getTime())) return '-';

  const adYear = d.getFullYear();
  const adMonth = d.getMonth(); // 0-11
  const adDay = d.getDate();

  // Base BS Year calculation
  let bsYear = adYear + 57;
  if (adMonth < 3 || (adMonth === 3 && adDay < 13)) {
    bsYear = adYear + 56;
  }

  // Days mapping relative to Baisakh 1 (approx April 13/14)
  const baisakh1AD = new Date(adMonth >= 3 ? adYear : adYear - 1, 3, 13);
  let diffDays = Math.floor((d.getTime() - baisakh1AD.getTime()) / (1000 * 60 * 60 * 24));
  if (diffDays < 0) diffDays = 0;

  const bsMonthDaysList = [31, 31, 32, 32, 31, 30, 30, 30, 30, 29, 30, 30];
  let bsMonthIndex = 0;
  let bsDay = diffDays + 1;

  for (let i = 0; i < 12; i++) {
    if (bsDay <= bsMonthDaysList[i]) {
      bsMonthIndex = i;
      break;
    }
    bsDay -= bsMonthDaysList[i];
  }

  const monthName = NEPALI_MONTHS_BS[bsMonthIndex] || 'Baisakh';
  const monthNum = String(bsMonthIndex + 1).padStart(2, '0');
  const dayNum = String(Math.min(32, Math.max(1, bsDay))).padStart(2, '0');

  if (format === 'full') {
    return `${bsYear} ${monthName} ${dayNum} BS`;
  }
  return `${bsYear}/${monthNum}/${dayNum} BS`;
};
